import { getSupportedLanguage } from './Language.js';
import { parseLocale } from './Locale.js';
/**
 * Extracts a supported language from an application locale, falling back to the default language.
 * @util
 * @__NO_SIDE_EFFECTS__
 */
export function getLocaleLanguage(locale) {
    const parsedLocale = locale ? parseLocale(locale) : null;
    return getSupportedLanguage(parsedLocale?.language);
}
//# sourceMappingURL=getLocaleLanguage.js.map